import logoLight from '@/images/logos/ReceiptsAI.svg'
import logoDark from '@/images/logos/ReceiptsAI-white.svg'
import Image, { ImageProps } from 'next/image'
import Link from 'next/link'

export interface LogoProps extends Omit<ImageProps, 'src' | 'alt'> {
  darkMode?: boolean
}

export function Logo({ darkMode = false, ...props }: LogoProps) {
  const logoSrc = darkMode ? logoDark : logoLight

  return (
    <Link href="https://receiptsai.com/">
      <Image src={logoSrc} alt="ReceiptsAI" width={112} {...props} />
    </Link>
  )
}